const rootAdm = process.env.REACT_APP_BACKEND_GCS + "/api";

const rutasBase = {
  provincias: rootAdm + "/provincia",
  servicios: rootAdm + "/servicio",
  sucursales: rootAdm + "/sucursal/publico",
  tiposconvenios: rootAdm + "/tipo-convenio/publico",
  convenios: rootAdm + "/convenios/publico",
  cantones: rootAdm + "/canton",
  distritos: rootAdm + "/distrito",
  bienes: rootAdm + "/bienes/sitio-publico",
  tipobien: rootAdm + "/tipobien",
  conveniosTiles: rootAdm + "/convenios/inicio",
};

export default rutasBase;
